import { useState } from "react";

const faqs = [
  {
    q: "¿Cuánto tiempo tarda la construcción de una piscina?",
    a: "El tiempo de construcción varía según el tamaño y tipo de piscina. Una piscina estándar de obra suele tardar entre 4 y 8 semanas. Las piscinas prefabricadas o de poliéster pueden instalarse en 1-2 semanas. Te daremos un plazo exacto en el presupuesto.",
  },

  {
    q: "¿Ofrecéis garantía en los trabajos realizados?",
    a: "Sí, todos nuestros trabajos de construcción tienen garantía de 10 años en estructura y 2 años en instalaciones. Las reparaciones tienen garantía de 1 año. Trabajamos con materiales de primera calidad y marcas reconocidas.",
  },

  {
    q: "¿Trabajáis en toda España?",
    a: "Sí, realizamos trabajos en toda España. Contamos con equipos en las principales ciudades y podemos desplazarnos a cualquier punto del territorio nacional para proyectos de construcción y grandes reparaciones.",
  },


];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-cyan-500 text-sm font-semibold uppercase tracking-widest">FAQ</span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-800 mt-3 mb-4">
            Preguntas Frecuentes
          </h2>
          <p className="text-slate-500 max-w-xl mx-auto text-base">
            Resolvemos las dudas más comunes sobre nuestros servicios. Si no encuentras tu respuesta, contáctanos directamente.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-xl overflow-hidden transition-all duration-300 ${
                openIndex === i ? "border-cyan-300 bg-cyan-50/50" : "border-slate-200 bg-white"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className={`font-semibold text-base ${openIndex === i ? "text-cyan-600" : "text-slate-800"}`}>
                  {faq.q}
                </span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ml-4 transition-all ${
                  openIndex === i ? "bg-cyan-500 text-white" : "bg-slate-100 text-slate-500"
                }`}>
                  <i className={`${openIndex === i ? "ri-subtract-line" : "ri-add-line"} text-sm`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-slate-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center bg-slate-50 rounded-2xl p-8">
          <i className="ri-question-answer-line text-4xl text-cyan-500 mb-3 block"></i>
          <h3 className="text-xl font-bold text-slate-800 mb-2">¿Tienes más preguntas?</h3>
          <p className="text-slate-500 text-sm mb-5">Nuestro equipo está disponible para resolver todas tus dudas.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="tel:+34642885747"
              className="bg-cyan-500 hover:bg-cyan-600 text-white font-semibold px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-phone-line mr-2"></i>Llamar ahora
            </a>
            <a
              href="https://wa.me/34642885747"
              target="_blank"
              rel="nofollow noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-whatsapp-line mr-2"></i>WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
